import cn from 'classnames';
import { InlineSvg } from 'components/svg';
import { FC, ReactNode } from 'react';

interface InfoSectionProps {
  children: ReactNode;
  variant?: 'default' | 'warning' | 'success' | 'danger';
  action?: ReactNode;
  className?: string;
}

const variantStyles = {
  default: {
    className: 'border-secondary bg-light-secondary',
    iconPath: '/media/svg/general/information.svg',
    textClass: 'text-secondary'
  },
  warning: {
    className: 'border-warning bg-light-warning',
    iconPath: '/media/svg/general/information.svg',
    textClass: 'text-warning'
  },
  danger: {
    className: 'border-danger bg-light-danger',
    iconPath: '/media/svg/general/information.svg',
    textClass: 'text-danger'
  },
  success: {
    className: 'border-success bg-light-success',
    iconPath: '/media/svg/general/information.svg',
    textClass: 'text-success'
  }
};

export const InfoSection: FC<InfoSectionProps> = ({ children, variant = 'default', action, className }) => {
  const { className: variantClassName, iconPath, textClass } = variantStyles[variant];

  return (
    <div className="d-flex justify-content-between align-items-center gap-3">
      <div
        className={cn(
          'd-flex gap-3 align-items-center border border-dashed rounded p-3 flex-grow-1',
          variantClassName,
          className
        )}
      >
        <InlineSvg path={iconPath} className={cn('svg-icon-2 text-current', textClass)} />
        {children}
      </div>
      {action}
    </div>
  );
};
